import { LoadablePaint } from '@confluence/loadable';

export const PopularLabelsMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PopularLabelsMacro" */ '../src/PopularLabelsMacroRenderer.tsx'
			)
		).PopularLabelsMacroRenderer,
});
